//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'underscore'
import moment from 'moment'
import Vue from 'vue'
// import DIC from '@/index/dictonary'

export default {
  props: {
    visible: {
      default: false
    },
    initialForm: {
      default: () => ({})
    }
  },
  data: function () {
    return {
      currentVisible: this.visible,
      loading: false,
      info: {
        payChannel: undefined,
        payType: undefined
      },
      LODOP: undefined
    }
  },
  watch: {
    visible: {
      handler (val) {
        this.currentVisible = val
      },
      immediate: true
    }
  },
  computed: {
    recordActive () {
      return (this.info.records && this.info.records.length !== undefined) ? this.info.records.length : 0
    }
  },
  components: {

  },
  mounted () {
    this.handleLoadData()
  },
  methods: {
    handleLoadData () {
      let data = _.pick(this.initialForm, 'orderId')
      this.loading = true
      this.$axios.get('/mtea/store/admin/order/info', { params: data }).then(res => {
        _.each(res.items, (t, i, l) => {
          if (t.goodsExtra) {
            l[i].goodsExtra = JSON.parse(t.goodsExtra)
          }
        })
        res.buyNumber = _.reduce(res.items, (memo, item) => {
          return memo + item.buyNumber
        }, 0)
        res.records = _.sortBy(res.records, function (t) {
          return moment(t.createTime).valueOf()
        })
        this.info = res
      }).finally(() => {
        this.loading = false
      })
    },
    handleOpen () {
      this.handleLoadData()
    },
    getPrintIndex () {
      var count = this.LODOP.GET_PRINTER_COUNT()
      // console.log('count', count)
      for (var i = 0; i < count; i++) {
        var name = this.LODOP.GET_PRINTER_NAME(i)
        // console.log('name', name)
        if (name == 'HP LaserJet Professional M1136 MFP') {
          return i
        }
      }
    },
    handlePrintByClodop () {
      if (window.getCLodop()) {
        var LODOP = window.getCLodop()
        this.LODOP = LODOP
        LODOP.On_Return_Remain = true
        LODOP.On_Return = function (taskId, value) {
          if (value === true) {
            this.$notify.success({ title: '系统提示', message: '打印机成功' })
          } else if (value === false) {
            this.$notify.error({ title: '系统提示', message: '打印机失败' })
          } else {
          }
        }
        var taskName = _.now()
        var value = this.getPrintIndex()
        this.info.payChannelText = Vue.filter('payChannel')(this.info.payChannel)
        this.info.payTypeText = Vue.filter('payType')(this.info.payType)
        var html = this.getPrintHtml({ info: this.info })
        // console.log('html', html)
        var marginLeft = 0
        var marginBottom = 50
        var height = '100%'
        LODOP.PRINT_INIT(taskName)
        // console.log('value', value)
        LODOP.SET_PRINTER_INDEXA(value)
        // 以纸张边缘为基点
        LODOP.SET_PRINT_MODE('POS_BASEON_PAPER', true)
        LODOP.ADD_PRINT_HTM('0%', marginLeft, '100%', height, html)
        LODOP.NewPageA()
        LODOP.SET_PRINT_PAGESIZE(3, 2100, marginBottom, '')
        LODOP.PREVIEW()
        LODOP.PRINT()
      } else {
        this.$notify.error({ title: '系统提示', message: '未连接到打印服务' })
      }
    },
    handlePrintByBrowser () {
      setTimeout(() => {
        let html = this.getPrintHtml({ info: this.info })
        let $ele = $('#printContent')
        if ($ele.length == 0) {
          $ele = $("<div id='printContent' style='position:absolute;top:-1000px;left:-1000px;display:none;'></div>").appendTo('body')
        }
        $ele.html(html)
        $ele.printThis({
          debug: false,
          importCSS: false,
          printContainer: false
        })
      }, 1000)
    },
    getPrintHtml (data) {
      let s = `<div style="font-size:14px;padding:15px;">
        <div style="margin-top:50px;position:relative">
          <div style="position:absolute;left:0px;top:0px;font-size:16px;font-weight:bold;">美加美茶楼管理系统</div>
          <div style="font-size:20px;text-align:center;">购物清单</div>
        </div>
        <div style="margin-top: 20px;">
          <span>订单编号:</span>
          <span style="margin-left:5px;font-size:12px;"><%=info.orderNo%></span>
          <span style="margin-left:10px;">订单时间:</span>
          <span style="margin-left:5px;font-size:12px;"><%=info.createTime%></span>
          <span style="margin-left:10px;">商铺名称:</span>
          <span style="margin-left:5px;"><%=info.shopName%></span>
          <span style="margin-left:10px;">客户姓名:</span>
          <span style="margin-left:5px;"><%=info.userName%></span>
        </div>
        <table border="1" bordercolor="#777777" style="width:100%;border-collapse:collapse;margin-top:10px;">
          <thead>
            <th>商品名称</th>
            <th>单价</th>
            <th>数量</th>
            <th>金额</th>
          </thead>
          <tbody>
            <%for(var i=0;i<info.items.length;i++){
              var item = info.items[i]
            %>
            <tr>
              <td>
                <div><strong><%=item.name%></strong><span style="margin-left:10px;"><%=item.goodsExtra.brandName%>  <%=item.goodsExtra.model%>  <%=item.goodsExtra.size%>  <%=item.goodsExtra.unit%></span></div>
              </td>
              <td>¥<%=item.price == undefined?0:Number((item.price / 100).toFixed(2))%></td>
              <td><%=item.buyNumber%></td>
              <td>¥<%=(item.totalAmount == undefined?0:Number((item.totalAmount / 100).toFixed(2)))%></td>
            </tr>
            <%}%>
          </tbody>
        </table>
        <div style="margin-top:20px;text-align:left;">
          <span>商品数量：</span> <span style="margin-left:5px;"><%=info.buyNumber%></span>
          <span style="margin-left:20px;">订单总金额：</span> <span style="margin-left:5px;">¥<%=Number((info.orderAmount / 100).toFixed(2))%></span>
          <%if(info.payChannel !== undefined){%><span style="margin-left:20px;">支付渠道：</span><span style="margin-left:5px;"><%=info.payChannelText%></span><%}%>
          <span style="margin-left:20px;">支付方式：</span> <span style="margin-left:5px;"><%=info.payTypeText%></span>
        </div>
        <div style="margin-top:10px;text-align:left;">
          <span>备注：</span> <span style="margin-left:5px;"><%=info.orderDesc%></span>
          </br>
          </br>
        </div>
        </br>
        </br>
        <br/>
        <div style="position:fixed;bottom:0px;left:0px;width:100%;padding:20px;">
          <hr style="margin-top:20px"/>
          <div style="position: relative;">
          </br>
          </br>
            <div style="font-size:20px;">美加美  茶楼产业先行者</div>
            <div style="margin-top:5px;">
              <div style="display:inline-block;">
                <div>美加美云商</div>
                <div style="margin-top:5px;">一键采购，送货上门</div>
              </div>
              <div style="display:inline-block;margin-left: 15px;">
                <div>美加美职场</div>
                <div style="margin-top:5px;">招聘求职，精英推荐</div>
              </div>
              <div style="display:inline-block;margin-left: 15px;">
                <div>美加美学堂</div>
                <div style="margin-top:5px;">行业动态，资源对接</div>
              </div>
            </div>
            <div style="position: absolute;right:155px;top:10px;">
              <img src="https://img.tea.mding.org/store/goods/f71b2674cc0755f04fc3a595b0c250bf!zip" style="width:90px;height:90px;"/>
              <div style="margin-top:5px;">扫码下载美加美APP</div>
            </div>
            <div style="position: absolute;right:0px;top:10px;">
              <img src="https://img.tea.mding.org/store/goods/463dd41c9c9a38d6e24c8b8ff77c6e3a!zip" style="width:90px;height:90px;"/>
              <div style="margin-top:5px;">扫码关注【美加美】</div>
            </div>
          </div>
        </div>
      </div`
      let templateFn = _.template(s)
      let r = templateFn(data)
      return r
    },
    handleClose () {
      _.extend(this, _.pick(this.$options.data(), 'info'))
    }
  }
}
